import { cn } from "@/lib/utils"

export const SidebarSkeleton = ({ collapsed }: { collapsed?: boolean }) => {
    return (
        <aside
            className={cn(
                "fixed left-0 top-0 z-10 flex h-screen flex-col bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800",
                collapsed ? "w-16" : "w-48"
            )}
        >
            {/* Logo */}
            <div className="flex items-center justify-center p-2 border-b border-gray-200 dark:border-gray-800">
                <div className="h-8 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
            </div>

            {/* Nav Items */}
            <div
                className={cn(
                    "flex-1 space-y-2 py-4",
                    collapsed ? "px-2" : "px-4"
                )}
            >
                {Array.from({ length: 6 }).map((_, i) => (
                    <div
                        key={i}
                        className={cn(
                            "flex items-center rounded-md animate-pulse",
                            collapsed ? "justify-center py-2" : "gap-3 px-3 py-2"
                        )}
                    >
                        {/* Icon */}
                        <div className="h-4 w-4 bg-gray-300 dark:bg-gray-600 rounded" />

                        {/* Text */}
                        {!collapsed && (
                            <div className="h-3 w-24 bg-gray-300 dark:bg-gray-600 rounded" />
                        )}
                    </div>
                ))}
            </div>

            {/* Bottom Buttons */}
            <div className={cn("border-t space-y-2", collapsed ? "p-2" : "p-4")}>
                <div className="h-8 w-full bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
                <div className="h-8 w-full bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
            </div>
        </aside>
    )
}